import {getCookie, setCookie} from 'typescript-cookie';
import {environment} from "../environments/environment";

export class _lookup {

    private getRemoteHostURL() {
        return `${environment.apiBaseUrl}/constants/lookup`;
    }

    lang: string;
    trTable: any;
    listTable: any;

    constructor(lang: string) {
      this.lang = lang;
    }

    async init() {
      return this.maybeLoad()
        .then(res => {
          (window as any).lookup=this;
          eval('let lookup=window.lookup')
        });
  }


  public async maybeLoad() {
    //Load from cache by default while we are possibly loading from server
    this.loadFromCache(null);

    return new Promise<void>((resolve, reject) => {
      fetch(this.getRemoteHostURL() + '/hash')
        .then(res => res.text())
        .then(async (hash) => {
          if (this.trTable == null || hash != getCookie(this.getCookieName(true))) {
            await this.loadFromRemote(hash);
          } else {
            // Cache is already loaded
            // this.loadFromCache(hash);
          }

          resolve();
        })
        .catch(err => reject())
      }
    )
  }


  private loadFromRemote(hash: string) {
    console.log("Loading lookup from remote");

    return new Promise<void>((resolve, reject) => {
      fetch(this.getRemoteHostURL())
        .then(res => res.text())
        .then(res => {
          this.updateTables(JSON.parse(res));
          localStorage.setItem(this.getCookieName(true), hash);
          setCookie(this.getCookieName(true), hash);
          localStorage.setItem(this.getCookieName(false), res);
          resolve();
        })
        .catch(err => reject())
    })
  }

    private loadFromCache(hash: string | null) {
        console.log("Loading lookup from cache");
        let tmp = localStorage.getItem(this.getCookieName(false));
        if (tmp != null) {
            this.updateTables(JSON.parse(tmp));
        }
    }

    private updateTables(data: any) {

        this.listTable = data;
        this.trTable = {};
        Object.keys(data).forEach(key => {
            this.trTable[key] = {};
            data[key].forEach(line => this.trTable[key][line.value] = line.displayValue);
        });
    }


    private getCookieName(hash: boolean) {
        return "lookup." + this.lang;
    }

    /**
     * Translate. Fall back to key if not found
     *
     * @param objFieldKey - for example  "com.instock.common.productivity.pojos.Activity:type"
     * @param key   "NOINV"
     */
    public tr(objFieldKey: string, key: string): string {
        let t = this.trTable[objFieldKey];
        if (t) {
            t = this.trTable[objFieldKey][key];
            if (t) {
                return t;
            }
        }
        return key;
    }

    public list(objFieldKey: string){
        return this.listTable[objFieldKey];

    }


    public async update() {
      return new Promise<void>((resolve, reject) => {
        fetch(this.getRemoteHostURL() + '/hash')
          .then(res => res.text())
          .then(async (hash) => {
              await this.loadFromRemote(hash);
              resolve();
          })
          .catch(err => reject())
      })
    }

}

export const lookup: _lookup = new _lookup("ru");

